import React from 'react';
import { Card, Descriptions } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import PermissionGuard from '../../components/PermissionGuard';
import { Modules } from '../../constants/permissions';
import { usePW9614Execute } from './hooks/usePW9614Execute';
import ExecuteParamsPanel from './components/ExecuteParams';
import ResultTable from './components/ResultTable';
import './PW9614Form.css';

const PW9614Form: React.FC = () => {
  const {
    year, setYear,
    month, setMonth,
    empFrom, setEmpFrom,
    empTo, setEmpTo,
    loading,
    result,
    status,
    errors,
    execute,
    preview,
  } = usePW9614Execute();

  return (
    <PermissionGuard module={Modules.PW9614} action="query">
      <div className="pw9614-container">
        <div className="pw9614-header">
          <h2><CalendarOutlined style={{ marginRight: 8 }} />請假月結作業</h2>
        </div>

        {/* Last run status */}
        {status && status.lastRunAt && (
          <div className="pw9614-status-card">
            <Descriptions size="small" column={4}>
              <Descriptions.Item label="上次執行年度">{status.lastYear}</Descriptions.Item>
              <Descriptions.Item label="上次執行月份">{status.lastMonth}</Descriptions.Item>
              <Descriptions.Item label="處理人數">{status.lastProcessed}</Descriptions.Item>
              <Descriptions.Item label="執行時間">
                {new Date(status.lastRunAt).toLocaleString('zh-TW')}
              </Descriptions.Item>
            </Descriptions>
          </div>
        )}

        {/* Execute parameters */}
        <Card title="執行參數" size="small" style={{ marginBottom: 16 }}>
          <ExecuteParamsPanel
            year={year}
            month={month}
            empFrom={empFrom}
            empTo={empTo}
            loading={loading}
            errors={errors}
            onYearChange={setYear}
            onMonthChange={setMonth}
            onEmpFromChange={setEmpFrom}
            onEmpToChange={setEmpTo}
            onExecute={execute}
            onPreview={preview}
          />
        </Card>

        {/* Results */}
        <Card title="月結結果" size="small">
          <ResultTable
            results={result?.results ?? null}
            processed={result?.processed ?? 0}
            loading={loading}
          />
        </Card>
      </div>
    </PermissionGuard>
  );
};

export default PW9614Form;
